export enum FlowStep {
    Introduction,
    Instruction,
    Memorize,
    Disruption,
    Play,
    Results,
    Summary,
}
